// Local service-provider categories (Plumber, Electrician, etc.)
// Alag hai product CATEGORIES (categories.js) se — ye "hire a person" ke liye hai.
export const SERVICE_CATEGORIES = [
  { key: 'plumber', icon: '🔧', label: 'Plumber' },
  { key: 'electrician', icon: '⚡', label: 'Electrician' },
  { key: 'painter', icon: '🎨', label: 'Painter' },
  { key: 'carpenter', icon: '🪚', label: 'Carpenter' },
  { key: 'ac_repair', icon: '❄️', label: 'AC Repair' },
  { key: 'appliance_repair', icon: '🔌', label: 'Appliance Repair' },
  { key: 'mason', icon: '🧱', label: 'Mason / Tile Work' },
  { key: 'cleaning', icon: '🧹', label: 'Cleaning' },
  { key: 'pest_control', icon: '🐜', label: 'Pest Control' },
  { key: 'mover', icon: '🚚', label: 'Movers & Packers' },
  { key: 'locksmith', icon: '🔑', label: 'Locksmith' },
  { key: 'gardener', icon: '🌱', label: 'Gardener' },
  { key: 'cctv_it', icon: '📷', label: 'CCTV / IT Repair' },
  { key: 'other', icon: '🛠️', label: 'Other' },
];
